import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from 'components/SuiButton';
import SuiAvatar from "components/SuiAvatar";
import axios from 'axios';
import Modal from '@mui/material/Modal';
import { useSnackbar } from "notistack";

function ProfileInfoCard({ title, info, status }) {
  const labels = [];
  const values = [];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [tenant, setTenant] = useState("");
  const [avatarKey, setAvatarKey] = useState(Date.now()); // Initialize with current timestamp

  console.log("Account status:" + status);
  Object.keys(info).forEach((el) => {
    if (el.match(/[A-Z\s]+/)) {
      const uppercaseLetter = Array.from(el).find((i) => i.match(/[A-Z]+/));
      const newElement = el.replace(uppercaseLetter, ` ${uppercaseLetter.toLowerCase()}`);
      labels.push(newElement);
    } else {
      labels.push(el);
    }
  });

  Object.values(info).forEach((el) => values.push(el));

  useEffect(() => {
    const fullNameIndex = labels.findIndex((label) => label === 'full name');
    if (fullNameIndex !== -1) {
      setTenant(values[fullNameIndex]);
    }
  }, [labels, values]);

  const handleEditClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFileUpload = async (file) => {
    const fileTypes = ["image/jpeg", "image/png"];
    if (!fileTypes.includes(file.type)) {
      enqueueSnackbar("Only PNG and JPEG files are allowed.", { variant: "error" });
      return;
    }

    try {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");

        const response = await axios.post(
          "https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/uploadSsm",
          {
            username: "",
            email: "",
            company: tenant,
            fileName: file.name,
            fileContent: base64String,
            fileType: file.type,
            fileCategory: "logo",
          }
        );

        if (response.status === 200) {
          enqueueSnackbar("File uploaded successfully.", { variant: "success" });
          setAvatarKey(Date.now()); // Update the key to trigger re-render
          handleCloseModal();
        } else {
          enqueueSnackbar("Failed to upload file.", { variant: "error" });
        }
      };

      reader.readAsDataURL(file);
    } catch (error) {
      enqueueSnackbar("An error occurred during file upload.", { variant: "error" });
    }
  };

  return (
    <Card sx={{ height: "100%" }}>
      <SuiBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
        <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {title}
        </SuiTypography>
      </SuiBox>
      <SuiBox px={2} pt={2}>
        <SuiBox display="flex">
          {status === "organizer" && (
            <>
              <SuiAvatar
                key={avatarKey}
                src={`https://certificatesys.s3.ap-southeast-1.amazonaws.com/${tenant}/logo?t=${avatarKey}`}
                alt="Avatar"
                size="xl"
              />
              <SuiAvatar bgColor="secondary" size="xs" onClick={handleEditClick} sx={{ cursor: "pointer" }}>
                <Icon>edit</Icon>
              </SuiAvatar>
            </>
          )}
        </SuiBox>
        <SuiBox opacity={0.3}>
          {/* <Divider /> */}
        </SuiBox>
        <SuiBox>
          {labels.map((label, key) => (
            <SuiBox key={label} display="flex" py={1} pr={2}>
              <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {label}: &nbsp;
              </SuiTypography>
              <SuiTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{values[key]}
              </SuiTypography>
            </SuiBox>
          ))}
        </SuiBox>
      </SuiBox>
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <SuiBox my="auto" mx="auto" py={3} p={2} bgColor={"white"} borderRadius="xl" display="flex">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleFileUpload(e.target.file.files[0]);
              e.target.reset();
            }}
          >
            <input type="file" name="file" accept="image/png, image/jpeg" style={{ marginBottom: '10px' }} />
            <SuiButton type="submit" variant="outlined" color="info">
              Upload
            </SuiButton>
          </form>
        </SuiBox>
      </Modal>
    </Card>
  );
}

ProfileInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.objectOf(PropTypes.string).isRequired,
  social: PropTypes.arrayOf(PropTypes.object).isRequired,
  action: PropTypes.shape({
    route: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProfileInfoCard;
